"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _OrsUtil = _interopRequireDefault(require("./OrsUtil.js"));

var _OrsInput = _interopRequireDefault(require("./OrsInput.js"));

var _OrsGeocode = _interopRequireDefault(require("./OrsGeocode.js"));

var _OrsIsochrones = _interopRequireDefault(require("./OrsIsochrones.js"));

var _OrsMatrix = _interopRequireDefault(require("./OrsMatrix.js"));

var _OrsDirections = _interopRequireDefault(require("./OrsDirections.js"));

var _OrsPois = _interopRequireDefault(require("./OrsPois.js"));

var _OrsElevation = _interopRequireDefault(require("./OrsElevation.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var Openrouteservice = {
  Util: _OrsUtil["default"],
  Input: _OrsInput["default"],
  Geocode: _OrsGeocode["default"],
  Isochrones: _OrsIsochrones["default"],
  Directions: _OrsDirections["default"],
  Matrix: _OrsMatrix["default"],
  Pois: _OrsPois["default"],
  Elevation: _OrsElevation["default"]
}; // Define Openrouteservice for Node module pattern loaders, including Browserify

if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && _typeof(module.exports) === 'object') {
  module.exports = Openrouteservice; // define Openrouteservice as an AMD module
  // eslint-disable-next-line no-undef
} else if (typeof define === 'function' && define.amd) {
  // eslint-disable-next-line no-undef
  define(Openrouteservice);
}

if (typeof window !== 'undefined') {
  window.Openrouteservice = Openrouteservice;
}

var _default = Openrouteservice;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/openrouteservice-js/lib/index.js
// module id = 1474
// module chunks = 0